import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formatNumberWithComma } from '../../../../../../utils/format-numbers.utils'
import Input from '../../../../../ui/input'
import { defaultStyle } from '../../../../../../constant/custom-style'
import { setBorrowerAgeAmount, setBorrowerAgeValue, setRemainingAgeAmount, UpdateBorrowerAgePayloadtype, visibleRemainingAge } from '../../../../../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.slice'
import SwitchYesNo from '../../../../../ui/switch-yes-no'
import { useToastify } from '../../../../../../library/toastify/toast-provider'
import { ForBorrowerAge } from '../../../../../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.state'

interface Props {
    tbody?: any[]
    isPreview: boolean
    isProductGPA: boolean
    isProductGCLI: boolean
    isProductGYRT: boolean
    isProductGCI: boolean
    borrowerAgeOptionsList: ForBorrowerAge[]
    minAge: number | null
    maxAge: number | null
}

export default function TBodyCoverage({ minAge, maxAge, borrowerAgeOptionsList, tbody, isPreview, isProductGPA, isProductGCLI, isProductGYRT, isProductGCI }: Props) {

    // const borrowerAgeOptionsList = useSelector(borrowerAgeOptionsState)
    // const minAge = useSelector(selectMinAge);
    // const maxAge = useSelector(selectMaxAge);

    const { showToastNotify } = useToastify();
    const showRate = isProductGCLI || isProductGYRT || isProductGCI
    const dispatch = useDispatch()
    const ageBracket = useSelector(visibleRemainingAge).filter(item => item.typeOfAge !== "under_min");
    const ageBracketList = borrowerAgeOptionsList.filter(item => item.isShow && !(isProductGCI && item.id === 6));

    const ageRemainingActive = isPreview ? ageBracket.filter(item => item.value) : ageBracket
    const ageBracketActive = isPreview ? ageBracketList.filter(item => item.value) : ageBracketList
    
    // const selectedRiders = useSelector(selectedRidersState);
    // const hasRiderOfAdditionalLifeCoverage = selectedRiders.some(rider => rider.id === PROPOSAL_RIDERS.ALCR.id);

    const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>, id: number, type: 'default' | 'rm' | 'ag') => {
        const value = e.target.value;
        const numericValue = parseFloat(value.replace(/,/g, ""));
        
        if(type === 'default') return dispatch(setBorrowerAgeAmount({ id, amount: numericValue }));
        // if(type === 'ag') return dispatch(setRemainingAgeAmount({ value: numericValue, type: 'ap' }));
        if(type === 'rm') return dispatch(setRemainingAgeAmount({ id, value: numericValue, type: 'rm' }));
    }

    const handleChange = (id: number, value: boolean, type: UpdateBorrowerAgePayloadtype, label: string) => {
        if (isPreview) return;
        
        const remainingAge = ageBracket.find(item => item.typeOfAge === "under_max")?.value;
        const isDefault = minAge === 18 && maxAge === 65;
        const age66to70 = ageBracketList.find(item => item.id === 3);
        const age71to75 = ageBracketList.find(item => item.id === 4);
        const age76to80 = ageBracketList.find(item => item.id === 5);

        if(type === 'fAge') {
            if(value) {
                if (id === 3 && !isDefault && !remainingAge) {
                    showToastNotify(`You can't select ${label} unless the lower age eligibility is selected.`,'warning')
                    return
                }

                if (id === 4 && age66to70?.value === false) {
                    showToastNotify(`You can't select ${label} unless the lower age eligibility is selected.`,'warning')
                    return
                }

                if (id === 5 && age71to75?.value === false) {
                    showToastNotify(`You can't select ${label} unless the lower age eligibility is selected.`,'warning')
                    return
                }
            } else {
                if (id === 3 && age71to75?.value) {
                    showToastNotify(`You can't unselect ${label} because 71-75 is still selected.`, "warning");
                    return;
                }
                if (id === 4 && age76to80?.value) {
                    showToastNotify( `You can't unselect ${label} because 76-80 is still selected.`, "warning");
                    return;
                }
            }
        }

        if(type === 'rAge' && !value && id == 3 && (age66to70?.value || age71to75?.value || age76to80?.value)) {
            showToastNotify( "You can't unselect.", "warning");
            return 
        }

        dispatch(setBorrowerAgeValue({ id, value, type }));
    };

    return (
        <tbody>
            {ageRemainingActive.map((rem) => (
                <tr key={rem.id} className="transition-colors hover:bg-gray-50">
                    <td className="w-[30%] border-b border-r border-gray-100 px-2 py-2.5 sm:px-3">
                        <div className="flex min-w-0 items-center gap-2">
                            <div className={`h-2 w-2 shrink-0 rounded-full ${rem.value ? "bg-[#186cb2]" : "bg-gray-300"}`}/>
                            <span className="break-words text-[11px] font-medium leading-4 text-gray-800 sm:text-xs">
                                {rem.label}
                            </span>
                        </div>
                    </td>
                    <td className="w-[50%] border-b border-gray-100 px-2 py-1.5 sm:px-3">
                        <Input
                            type="text"
                            name=""
                            value={formatNumberWithComma(rem.amount ?? "")}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !rem.amount ? "" : isPreview ? "" : "border-[#186cb2] bg-[#186cb2]/10" }`}
                            onChange={(e) => handleChangeInput(e, rem.id, "rm")}
                            required={true}
                            placeholder={isPreview ? "" : `Enter benefit amount for ${rem.label}`}
                            disabled={isPreview || !(rem.value ?? false)}
                        />
                    </td>
                    <td className="w-[20%] border-b border-l border-gray-100 px-1 py-1.5 text-center sm:px-3">
                        <SwitchYesNo
                            isPreview={isPreview}
                            value={rem.value}
                            id={rem.id}
                            onChange={handleChange}
                            type="rAge"
                            label={rem.label}
                        />
                    </td>
                </tr>
            ))}

            {showRate &&
                [...ageBracketActive]
                    .sort((a, b) => a.id - b.id)
                    .map((body) => (
                        <tr key={body.id} className="transition-colors hover:bg-gray-50">
                            <td className="w-[30%] border-b border-r border-gray-100 px-2 py-2.5 sm:px-3">
                                <div className="flex min-w-0 items-center gap-2">
                                    <div className={`h-2 w-2 shrink-0 rounded-full ${body.value ? "bg-[#186cb2]" : "bg-gray-300"}`}/>
                                    <span className="break-words text-[11px] font-medium leading-4 text-gray-800 sm:text-xs">
                                        {body.label}
                                    </span>
                                </div>
                            </td>
                            <td className="w-[50%] border-b border-gray-100 px-2 py-1.5 sm:px-3">
                                <Input
                                    type="text"
                                    name="selectCommissionValue"
                                    value={formatNumberWithComma(body.amount ?? "")}
                                    isCustomStyle={true}
                                    customCss={`${defaultStyle} ${ !body.amount ? "" : isPreview ? "" : "border-[#186cb2] bg-[#186cb2]/10" }`}
                                    onChange={(e) => handleChangeInput(e, body.id, "default")}
                                    required={true}
                                    placeholder={ isPreview ? "" : `Enter benefit amount for ${body.label}`}
                                    disabled={isPreview || !(body.value ?? false)}
                                />
                            </td>
                            {!isProductGPA && (
                                <td className="w-[20%] border-b border-l border-gray-100 px-1 py-1.5 text-center sm:px-3">
                                    <SwitchYesNo
                                        isPreview={isPreview}
                                        value={body.value}
                                        id={body.id}
                                        onChange={handleChange}
                                        type="fAge"
                                        label={body.label}
                                    />
                                </td>
                            )}
                        </tr>
                    ))}
        </tbody>
    )
}
